module.exports = __webpack_public_path__ + "img/update-green-pipboy.33256a2f.png";